import { render } from "./BlogArticles.vue?vue&type=template&id=2250318c"
import script from "./BlogArticles.vue?vue&type=script&lang=js"
export * from "./BlogArticles.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__